<template>
  <div>
    <Header />
    <Nav />
    <div class="body pb70">
      <div class="menu bgc"></div>
      <div class="container">
        <div class="newsBox">
          <div class="banner"></div>
          <div class="filterBar">
            <div class="search">
              <input
                type="text"
                placeholder="输入关键字搜索"
                v-model="searchVal"
              />
            </div>
            <Btn
              btnText="返回上一页"
              :width="91"
              :height="30"
              :radius="15"
              @handleClick="$router.go(-1)"
            />
          </div>
          <div class="qList">
            <div class="qItem" v-for="(item, index) in list" :key="item.id">
              <div class="qPanel">
                <div class="title">
                  <i class="icon_question"></i>
                  <div>
                    {{ item.title }}
                  </div>
                </div>
                <button @click="handleToggle(index)">
                  {{ item.toggled ? "收起" : "展开" }}回答<i
                    :class="item.toggled ? 'fold' : 'unfold'"
                  ></i>
                </button>
              </div>
              <div
                class="qContent"
                v-html="item.content"
                v-if="item.toggled"
              ></div>
            </div>
            <!--  -->
          </div>
          <div class="text-right">
            <pagination
              v-if="total > 0"
              :total="total"
              :page.sync="listQuery.current"
              :limit.sync="listQuery.size"
              class="no-print"
              @pagination="getList"
            />
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Btn from "../../components/Btn.vue";
import Footer from "../../components/Footer.vue";
import Header from "../../components/Header.vue";
import Nav from "../../components/Nav.vue";
import { questionList } from "@/api/question";
import Pagination from "@/components/Pagination.vue";

export default {
  components: { Header, Footer, Nav, Btn, Pagination },
  data() {
    return {
      total: 0,
      listQuery: {
        current: 1,
        size: 10
      },
      list: [],
      searchVal: ""
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      questionList(this.listQuery).then(res => {
        this.list = res.data.d.records;
        this.total = res.data.d.total;
        this.list.map(item => {
          this.$set(item, "toggled", false);
        });
      });
    },
    handleToggle(index) {
      this.list[index].toggled = !this.list[index].toggled;
    }
  },
  watch: {
    listQuery: {
      handler(val) {
        console.log(val);
        this.getList();
      },
      deep: true
    },
    searchVal(val) {
      this.listQuery.current = 1;
      this.listQuery.title = val;
      this.getList();
    }
  }
};
</script>

<style scoped lang="scss">
.text-right {
  text-align: right;
}
.body {
  padding-bottom: 70px;
  display: inline-block;
  width: 100%;
  background-color: #f0f2f5;
  .newsBox {
    padding: 30px 57px;
    margin: 40px 0 0px 0;
    line-height: 30px;
    background: #fff;
    font-size: 14px;
    color: #6e6e6e;
    .banner {
      background: url("../../assets/qabanner.png");
      background-size: cover;
      width: 100%;
      height: 131px;
      margin-bottom: 37px;
    }
    .search {
      input {
        background: url("../../assets/icon_search.png") no-repeat;
        background-position: 93% center;
        background-size: 13px;
        border: 1px solid #d7d7d7;
        border-radius: 19px;
        width: 217px;
        height: 37px;
        box-sizing: border-box;
        padding-left: 18px;
        padding-right: 17%;
        &:focus {
          outline: none;
        }
      }
    }

    .filterBar {
      display: flex;
      justify-content: space-between;
    }
    .qList {
      border-top: 2px solid #f0f2f5;
      margin-top: 37px;
      .qItem {
        padding-top: 34px;
        padding-bottom: 33px;
        border-bottom: 1px solid #f0f2f5;
        .qPanel {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .icon_question {
            background: url("../../assets/icon_question.png");
            background-size: cover;
            width: 17px;
            height: 18px;
            display: inline-block;
            margin-right: 17px;
          }
          .title {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #393939;
            display: flex;
            align-items: center;
          }
          button {
            outline: none;
            background: #ffffff;
            border: 1px solid #3a61b1;
            border-radius: 4px;
            width: 80px;
            height: 27px;
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #3a61b1;
            cursor: pointer;
            i {
              background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_arrow_left.png")
                no-repeat;
              background-size: cover;
              width: 5px;
              height: 9px;
              display: inline-block;
              margin-left: 5px;
            }
            .fold {
              transform: rotate(90deg);
            }
            .unfold {
              transform: rotate(270deg);
            }
          }
        }
        .qContent {
          padding-left: 35px;
          padding-top: 10px;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #a2a2a2;
          line-height: 22px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/QA/list.vue